import { useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, Globe, LayoutGrid, LogOut, X } from "lucide-react";

const QUICK = {
  appuntamenti: { Icon: CalendarDays, short: "Agenda" },
  sito: { Icon: Globe, short: "Sito" },
};

/* Navigazione da smartphone (solo <768px): barra inferiore stile app + menu a schermata piena. */
export default function AdminMobileNav({ tabs, activeTab, onPick, onLogout }) {
  const [open, setOpen] = useState(false);
  const quick = Object.keys(QUICK)
    .map((key) => tabs.find((t) => t.key === key))
    .filter(Boolean);
  const inMenu = tabs.some((t) => t.key === activeTab);
  return (
    <>
      <nav
        className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-ivory/95 backdrop-blur-xl border-t border-taupe/25"
        data-testid="admin-bottom-bar"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        <div className="flex items-stretch">
          {quick.map(({ key, short }) => {
            const { Icon } = QUICK[key];
            const active = activeTab === key;
            return (
              <button
                key={key}
                onClick={() => onPick(key)}
                data-testid={`admin-bottom-${key}`}
                className={`flex-1 flex flex-col items-center gap-1 py-2.5 text-[10px] uppercase tracking-widest2 font-medium transition-colors duration-200 ${active ? "text-deeptaupe" : "text-charcoal/50"}`}
              >
                <Icon size={20} />
                {short}
              </button>
            );
          })}
          <button
            onClick={() => setOpen(true)}
            data-testid="admin-bottom-menu"
            className={`flex-1 flex flex-col items-center gap-1 py-2.5 text-[10px] uppercase tracking-widest2 font-medium transition-colors duration-200 ${inMenu && !quick.some((t) => t.key === activeTab) ? "text-deeptaupe" : "text-charcoal/50"}`}
          >
            <LayoutGrid size={20} /> Menu
          </button>
        </div>
      </nav>

      {open && (
        <div className="fixed inset-0 z-50 md:hidden bg-ivory flex flex-col" data-testid="admin-mobile-menu">
          <div className="flex items-center justify-between px-5 h-16 border-b border-taupe/25">
            <img src="/images/logo-transparent.png" alt="K Nutrition" className="h-8" />
            <button onClick={() => setOpen(false)} data-testid="admin-mobile-menu-close" className="p-2 -mr-2 text-charcoal/60" aria-label="Chiudi menu">
              <X size={22} />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto px-5 py-6 space-y-2">
            {tabs.map((t) => (
              <button
                key={t.key}
                onClick={() => {
                  onPick(t.key);
                  setOpen(false);
                }}
                data-testid={`admin-mobile-menu-item-${t.key}`}
                className={`w-full text-left rounded-2xl px-5 py-4 text-base font-medium transition-colors duration-200 flex items-center justify-between gap-3 ${t.key === activeTab ? "bg-deeptaupe text-ivory" : "bg-white text-charcoal border border-taupe/25"}`}
              >
                <span>{t.label}</span>
                {t.badge > 0 && (
                  <span
                    className="inline-flex items-center justify-center min-w-[22px] h-[22px] px-1.5 rounded-full bg-peach text-deeptaupe text-[12px] font-medium"
                    data-testid={`admin-menu-badge-${t.key}`}
                  >
                    {t.badge}
                  </span>
                )}
              </button>
            ))}
          </div>
          <div className="px-5 pb-8 pt-4 border-t border-taupe/25 flex items-center justify-between gap-3">
            <Link to="/" data-testid="admin-mobile-menu-site" className="text-[12px] uppercase tracking-widest2 text-charcoal/60 hover:text-deeptaupe">
              Vai al sito
            </Link>
            <button
              onClick={async () => {
                setOpen(false);
                await onLogout();
              }}
              data-testid="admin-mobile-menu-logout"
              className="flex items-center gap-1.5 text-[12px] uppercase tracking-widest2 text-deeptaupe hover:text-charcoal"
            >
              <LogOut size={14} /> Esci
            </button>
          </div>
        </div>
      )}
    </>
  );
}
